var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "head-border" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("img", {
              staticClass: "logo_img",
              attrs: { src: require("@/assets/img/shopvidi_logo.png") },
              on: { click: _vm.gotoShopvidi }
            }),
            _vm._v(" "),
            _c("el-divider", { attrs: { direction: "vertical" } }),
            _vm._v(" "),
            _c("div", { staticClass: "header-content" }, [
              _vm._v("Wholesale Partner Program")
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "review-main-border" }, [
        _c(
          "div",
          { staticClass: "review-main" },
          [
            _c(
              "el-steps",
              {
                staticClass: "pc-steps",
                attrs: {
                  active: _vm.active,
                  "finish-status": "success",
                  "align-center": ""
                }
              },
              [
                _c("el-step", { attrs: { title: "Register" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "Profile" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "Review" } })
              ],
              1
            ),
            _vm._v(" "),
            _vm.active === 2
              ? _c(
                  "div",
                  { staticClass: "review-main-content" },
                  [
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Company and Location Details")
                    ]),
                    _vm._v(" "),
                    _c("el-divider"),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Company Details")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "businessForm1",
                        staticClass: "business-form",
                        attrs: { model: _vm.businessForm, rules: _vm.rules }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "companyName",
                              label: "Company Name (Registered) "
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "eg.ShopVidi" },
                              model: {
                                value: _vm.businessForm.companyName,
                                callback: function($$v) {
                                  _vm.$set(_vm.businessForm, "companyName", $$v)
                                },
                                expression: "businessForm.companyName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "yearOfEstablishment",
                              label: "Year of Establishment"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "eg.1999" },
                              model: {
                                value: _vm.businessForm.yearOfEstablishment,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessForm,
                                    "yearOfEstablishment",
                                    $$v
                                  )
                                },
                                expression: "businessForm.yearOfEstablishment"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "companyWebsite",
                              label: "Company Website"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "eg.www.shopvidi.com" },
                              model: {
                                value: _vm.businessForm.companyWebsite,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessForm,
                                    "companyWebsite",
                                    $$v
                                  )
                                },
                                expression: "businessForm.companyWebsite"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Company Address")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "businessForm2",
                        staticClass: "business-form",
                        attrs: { model: _vm.businessForm, rules: _vm.rules }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "street", label: "Street" } },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "eg.3427 Oakcliff Rd Ste 100"
                              },
                              model: {
                                value: _vm.businessForm.street,
                                callback: function($$v) {
                                  _vm.$set(_vm.businessForm, "street", $$v)
                                },
                                expression: "businessForm.street"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "city", label: "City" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "eg.Doraville" },
                                      model: {
                                        value: _vm.businessForm.city,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.businessForm,
                                            "city",
                                            $$v
                                          )
                                        },
                                        expression: "businessForm.city"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "state", label: "State" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "eg.Doraville" },
                                      model: {
                                        value: _vm.businessForm.state,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.businessForm,
                                            "state",
                                            $$v
                                          )
                                        },
                                        expression: "businessForm.state"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "countryCode",
                                      label: "Country"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "Enter Country"
                                        },
                                        model: {
                                          value: _vm.businessForm.countryCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.businessForm,
                                              "countryCode",
                                              $$v
                                            )
                                          },
                                          expression: "businessForm.countryCode"
                                        }
                                      },
                                      _vm._l(_vm.countryArr, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: index,
                                            attrs: {
                                              label: item.text,
                                              value: item.value
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" }
                                              },
                                              [_vm._v(_vm._s(item.text))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px"
                                                }
                                              },
                                              [_vm._v(_vm._s(item.value))]
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop: "zipCode",
                                      label: "ZIP Code"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "eg.30340",
                                        maxlength: "10"
                                      },
                                      model: {
                                        value: _vm.businessForm.zipCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.businessForm,
                                            "zipCode",
                                            $$v
                                          )
                                        },
                                        expression: "businessForm.zipCode"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Industry Type")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "businessForm3",
                        staticClass: "business-form",
                        attrs: { model: _vm.businessForm, rules: _vm.rules }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { prop: "categories", label: "Categories" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  multiple: "",
                                  placeholder: "Please Choose"
                                },
                                on: { change: _vm.chooseCategories },
                                model: {
                                  value: _vm.businessForm.categories,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.businessForm,
                                      "categories",
                                      $$v
                                    )
                                  },
                                  expression: "businessForm.categories"
                                }
                              },
                              _vm._l(_vm.options, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Brands Worked With In The Past")
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.brands && _vm.brands.length > 0
                      ? _c(
                          "div",
                          { staticClass: "brands_img_border" },
                          _vm._l(_vm.brands, function(items) {
                            return _c(
                              "div",
                              {
                                key: items.id,
                                staticClass: "brands_img",
                                on: {
                                  click: function($event) {
                                    return _vm.selectedBrand(items)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  staticClass: "brand_img",
                                  attrs: { src: items.brandLogoUrl }
                                }),
                                _vm._v(" "),
                                _vm.businessForm.selectedBrands &&
                                _vm.businessForm.selectedBrands.indexOf(
                                  items.id
                                ) > -1
                                  ? _c("img", {
                                      staticClass: "brand_selected_img",
                                      attrs: {
                                        src: require("@/assets/img/review_brand_right_top.png")
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "brands_img_border_text" }, [
                          _vm._v("Please choose the categories")
                        ]),
                    _vm._v(" "),
                    _vm.brandsMessage
                      ? _c("div", { staticClass: "tips_error" }, [
                          _vm._v("Please choose the brands")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "businessForm4",
                        staticClass: "business-form",
                        attrs: { model: _vm.businessForm, rules: _vm.rules }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "agencyTerritory",
                              label: "Agency Territory"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "Please Choose" },
                                model: {
                                  value: _vm.businessForm.agencyTerritory,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.businessForm,
                                      "agencyTerritory",
                                      $$v
                                    )
                                  },
                                  expression: "businessForm.agencyTerritory"
                                }
                              },
                              _vm._l(_vm.agencyTerritories, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "purchaseAmountMonth",
                              label: "Purchase amount/month"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "Please Choose" },
                                model: {
                                  value: _vm.businessForm.purchaseAmountMonth,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.businessForm,
                                      "purchaseAmountMonth",
                                      $$v
                                    )
                                  },
                                  expression: "businessForm.purchaseAmountMonth"
                                }
                              },
                              _vm._l(_vm.purchaseAmountMonths, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "ein", label: "EIN" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "eg.30340" },
                              model: {
                                value: _vm.businessForm.ein,
                                callback: function($$v) {
                                  _vm.$set(_vm.businessForm, "ein", $$v)
                                },
                                expression: "businessForm.ein"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "review-main-content-title" }, [
                      _vm._v("Documents Uploads")
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.businessForm
                      ? _c("img-swiper-review", {
                          staticClass: "img_swiper",
                          attrs: {
                            edit: true,
                            obj: _vm.businessForm,
                            imgListMessage:
                              _vm.businessForm.companyRegisteredAddressProof,
                            imgProperty: "companyRegisteredAddressProof",
                            id: "1"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.companyRegisteredAddressProofMessage
                      ? _c("div", { staticClass: "tips_error" }, [
                          _vm._v(
                            " Please upload the Company Registered Address Proof"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "review-main-content-sub_title" },
                      [_vm._v("Company Profile")]
                    ),
                    _vm._v(" "),
                    _vm.businessForm
                      ? _c("img-swiper-review", {
                          staticClass: "img_swiper",
                          attrs: {
                            edit: true,
                            obj: _vm.businessForm,
                            imgListMessage: _vm.businessForm.companyProfile,
                            imgProperty: "companyProfile",
                            id: "2"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "review-main-content-sub_title" },
                      [_vm._v("Qualification Certificate")]
                    ),
                    _vm._v(" "),
                    _vm.businessForm
                      ? _c("img-swiper-review", {
                          staticClass: "img_swiper",
                          attrs: {
                            edit: true,
                            obj: _vm.businessForm,
                            imgListMessage:
                              _vm.businessForm.qualificationCertificate,
                            imgProperty: "qualificationCertificate",
                            id: "3"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "review-main-content-action",
                        on: {
                          click: function($event) {
                            return _vm.submit("businessForm")
                          }
                        }
                      },
                      [_vm._v("Next")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.active === 3
              ? _c("div", { staticClass: "review_result" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/img/in_review.png") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "review_result_title" }, [
                    _vm._v("In Review")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review_result_tips" }, [
                    _vm._v(
                      "Your submitted information is currently under review. The audit will be completed within 48 hours."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "review_result_action",
                      on: { click: _vm.gotoHome }
                    },
                    [_vm._v("Back Home")]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("home-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "review-main-content-sub_title" }, [
      _vm._v("Brands "),
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")]),
      _vm._v(" (Brands I am hoping to cooperate with)")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "review-main-content-sub_title" }, [
      _vm._v("Company Registered Address Proof "),
      _c("span", { staticStyle: { color: "#F56C6C" } }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59504ac3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59504ac3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/review/review.vue
// module id = M+fk
// module chunks = 2